import React  from "react";

function NotificationModal(props) {
    return (
        <div>
            <div className="modal-text">
              <p> Your request for cancellation has been forwarded to our customer success team.They will get in touch with you shortly for further steps.</p>
            <b>Please Note:</b>Your subscription will be paused effect immediately
                <button className="btn" style={{marginLeft:"178px",marginTop:"20px",marginBottom:"10px"}}
                    onClick={() => props.toggle()}>
                    Cancel
                </button>
            </div>
        </div>
    )
}
export default NotificationModal;